export default __webpack_public_path__ + "static/media/sad.a8ad3acf.png";